import script from "./SetupStoreDetailsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupStoreDetailsStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import CateringField from "@/components/catering/CateringField.vue";
import GlowFrame from "@/components/catering/GlowFrame.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import OptionCard from "@/components/catering/OptionCard.vue";
import Pill from "@/components/catering/Pill.vue";
import SwooshArrow from "@/components/catering/SwooshArrow.vue";
script.components = Object.assign({}, { CateringField, GlowFrame, NeueButton, OptionCard, Pill, SwooshArrow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { CateringField, GlowFrame, NeueButton, OptionCard, Pill, SwooshArrow }, script.__o.components);}